import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export default function CompetencyRowSkeleton() {
  return (
    <Card className="mb-6 border-ctu-border shadow-none">
      <CardContent className="grid grid-cols-1 gap-0 p-0 lg:grid-cols-2 lg:divide-x">
        <div className="p-6 lg:p-8 border-b lg:border-b-0">
          <div className="mb-3 flex items-center justify-between">
            <Skeleton className="h-3 w-32" />
            <Skeleton className="h-3 w-20" />
          </div>
          <div className="flex flex-col divide-y divide-border">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="flex items-center gap-4 py-2.5">
                <Skeleton className="h-3 w-3 shrink-0" />
                <Skeleton className="h-3 flex-1 max-w-[160px]" />
                <Skeleton className="h-1 w-24 hidden sm:block" />
                <Skeleton className="h-3 w-8" />
              </div>
            ))}
          </div>
        </div>
        <div className="p-6 lg:p-8">
          <div className="mb-3">
            <Skeleton className="h-3 w-32 mb-2" />
            <Skeleton className="h-3 w-48" />
          </div>
          <div className="flex flex-1 items-center justify-center pt-2">
            <Skeleton className="aspect-square w-full max-w-[420px] rounded-full" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
